<template>
  <div>
    <div class="d-flex flex-column">
      <div class="d-flex align-content-start flex-wrap bg-primary pt-4 pl-4">
        <div class="ml-1 mr-2" style="width: auto;">
          <timePicker @change="changeDataPicker" />
        </div>
        <div class="ml-1 mr-2">
          <v-text-field
            type="number"
            label="Número Telefonico"
            v-model="phone"
            single-line
            solo
            hint="Ingrese Número Telefonico"
          ></v-text-field>
        </div>
        <!-- <div class="ml-1 mr-2">
            <v-select :items="FiltrosAleatorios" label="Aleatorio" solo></v-select>
          </div>-->
        <div class="mt-1 ml-1 mr-2">
          <v-btn @click="toggleFilterPanel">
            <v-icon v-text="iconFilterAdvanced"></v-icon>
          </v-btn>
        </div>
        <div class="mt-1 mr-2">
          <v-btn color="white" :disabled="!isValidSearch()" @click="search"
            >Buscar</v-btn
          >
        </div>
        <div class="mt-1 mr-2">
          <v-btn color="white" to="/calls/tagcomments">
            Etiquetas
            <v-icon>mdi-cog-outline</v-icon>
          </v-btn>
        </div>
      </div>
    </div>
    <div class="ml-5 mr-5">
      <callsFilter
        :open="showFilters"
        :selecttag="selecttag"
        v-on:RemoveTag="removeTag"
        v-on:addTags="addTag"
      />
    </div>
    <callsTable
      class="alignTablaSobreFondo ml-5 mr-5 mt-11"
      v-on:selectedTag="addTag"
      :calls="calls"
      @selectCall="setSelectCall"
      @lastId="pagination"
    />
    <div class="mt-10 ml-5 space">
      <v-btn
        class="button-secondary"
        tile
        text
        outlined
        :disabled="isValidDownloads"
        @click="getRecordings"
        :loading="isLoading"
        >Descargar</v-btn
      >
      <v-menu v-if="calls && calls.length > 0" bottom offset-x>
        <template v-slot:activator="{ on }">
          <div class="split-btn ml-5">
            <v-btn
              class="button-secondary-large main-btn"
              tile
              text
              outlined
              @click="downloadInCsv"
              >Listado en formato CSV</v-btn
            >
            <v-btn
              v-if="isClientAdmin || isSuperAdmin"
              color="white"
              v-on="on"
              class="actions-btn"
              ><v-icon>mdi-menu-down</v-icon></v-btn
            >
          </div>
        </template>
        <v-list-item link>
          <v-list-item-title @click="DownloadAll">
            Descargar todas
          </v-list-item-title>
        </v-list-item>
        <v-list-item link>
          <v-list-item-title
            @click="(isActiveModal = true), (selectOption = 'filenameFormat')"
          >
            Descargar con Etiqueta
          </v-list-item-title>
        </v-list-item>
        <v-list-item link>
          <v-list-item-title
            @click="(isActiveModal = true), (selectOption = 'storage')"
          >
            Descargar al Bucket
          </v-list-item-title>
        </v-list-item>
      </v-menu>
    </div>
    <div>
      <modalTag
        :tipeOption="selectOption"
        :isActive="isActiveModal"
        @save="selectedOption"
        @close="isActiveModal = false"
      />
    </div>
    <v-snackbar v-model="showError" color="red" :timeout="5000" max-width="100">
      {{ textError }}
    </v-snackbar>
  </div>
</template>
<script>
import { DateTime } from "luxon";
import modalTag from "../../components/calls/filenameFormatModal"; //Modal donde se seleccionara la etiqueta o el bucket del usuario.
import callsTable from "../../components/calls/callsTable";
import { httpByCurrentCustomer, downloadFromBlob } from "../../lib/client";
import timePicker from "../../components/timePicker";
import callsFilter from "../../components/calls/callsFilter";
// import { callFilterEmit } from "../../components/calls/callsFilter.vue";
import { mapGetters } from "vuex";

export default {
  data: () => ({
    dates: "",
    isLoading: false,
    selectCall: [],
    phone: "",
    iconFilterAdvanced: "mdi-filter-plus",
    showFilters: false,
    filters: null,
    selecttag: [],
    skip: null,
    isActiveModal: false,
    selectTagId: "",
    selectStorageId: "",
    selectOption: "",
    showError: false,
    textError: "",
  }),
  components: {
    callsTable,
    callsFilter,
    timePicker,
    modalTag, //La modal que nos servira para seleccionar el tag o bucket
  },
  mounted() {
    this.getDataTagComments();
  },
  methods: {
    changeDataPicker(value) {
      this.dates = value;
    },
    search() {
      if (this.isValidSearch()) {
        //TODO Queda pendiente cambiar el tag. Ya que apunta directamente con la zona horaria de Mexico.
        this.$store.dispatch("getCalls", this.createdRequest());
      }
    },
    removeTag(value) {
      this.selecttag = this.selecttag.filter((item) => {
        return item != value;
      });
    },
    addTag(value) {
      if (value != this.selecttag[this.selecttag.length - 1]) {
        this.selecttag.push(value);
      }
      this.showFilters = true;
    },
    setSelectCall(value) {
      this.selectCall = value;
    },
    isValidSearch() {
      return this.dates && this.dates.startDate && this.dates.endDate;
    },
    toggleFilterPanel() {
      this.showFilters = !this.showFilters;
      if (this.showFilters) {
        this.iconFilterAdvanced = "mdi-chevron-up";
      } else {
        this.iconFilterAdvanced = "mdi-filter-plus";
      }
    },
    getRecordings() {
      this.isLoading = true;
      const json = {
        listRecordings: this.selectCall,
      };
      httpByCurrentCustomer()
        .post("recordings", { json })
        .blob()
        .then((res) => {
          downloadFromBlob(res, "audios.zip");
          this.isLoading = false;
        });
    },
    DownloadAll() {
      // Aqui se hara la solicitud para descargar todas las grabaciones
      this.$store.dispatch("task/createTask", this.createdRequest());
      this.$router.push(`/task`);
    },
    updateLocalStorageTags(itemTags) {
      try {
        const tags = itemTags.map((x) => x.split(":")[0]);
        if (localStorage.getItem("defaultTags")) {
          const tagsLocalStorage = JSON.parse(
            localStorage.getItem("defaultTags")
          );
          const alltags = [].concat(
            tagsLocalStorage,
            this.selecttag.map((x) => x.split(":")[0])
          );
          const uniqueTags = [...new Set(alltags)];
          localStorage.setItem("defaultTags", JSON.stringify(uniqueTags));
          return;
        }
        localStorage.setItem("defaultTags", JSON.stringify(tags));
      } catch (error) {
        return;
      }
    },
    downloadInCsv() {
      const json = this.createdRequest();
      httpByCurrentCustomer()
        .post("recordings/export/csv", { json })
        .blob()
        .then((res) => {
          downloadFromBlob(res, "calls.csv");
          this.isLoading = false;
        });
    },
    createdRequest() {
      const req = {
        phone: this.phone,
        start: DateTime.fromISO(this.dates.startDate.toISOString(), {
          zone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        }),
        end: DateTime.fromISO(this.dates.endDate.toISOString(), {
          zone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        }),
        tags: [],
        skip: this.skip,
        customerAudioFormatId: Number(this.selectTagId),
        customerStorageId: Number(this.selectStorageId),
      };
      if (this.selecttag) {
        this.updateLocalStorageTags(this.selecttag);
        req.tags = this.selecttag;
      }
      return req;
    },
    pagination(item) {
      //Igualamos la variable a la fecha que le pasamos desde el componente hijo (callsTable.vue)
      this.skip = item;
      this.$store.dispatch("getCallsPagination", this.createdRequest());
    },
    selectedOption(value) {
      (this.selectTagId = value.customerAudioFormatId),
        (this.selectStorageId = value.customerStorageId);
      this.DownloadAll();
    },
    async getDataTagComments() {
      try {
        await this.$store.dispatch("tagConfigComments/getTagComments");
      } catch (error) {
        this.textError = error;
        this.showError = true;
      }
    },
  },
  computed: {
    ...mapGetters("auth", ["isSuperAdmin", "isClientAdmin", "userName"]),
    ...mapGetters({ calls: "callsTable", loading: "callsLoading" }),
    isValidDownloads() {
      return this.selectCall.length > 25 || this.selectCall.length === 0; // Valida que el usuario haya seleccionado alguna llamada.
    },
  },
};
</script>
<style scoped>
.space {
  margin-bottom: 90px;
}
.main-btn {
  border-top-right-radius: 0;
  z-index: 1;
  border-bottom-right-radius: 0;
}
.actions-btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  padding: 0 !important;
  min-width: 35px !important;
  margin-left: -3.5px;
  z-index: 1;
}
.split-btn {
  z-index: 1;
  display: inline-block;
}
.WidthCalendar {
  width: 22em;
}
</style>
<style src="@/styles/templateTable.css"></style>
